import React from 'react';
import ListViewSwitcher from './basic-switch';
import InvestorsViewSwitcher from './investors-switch';
import { SearchViewMode } from './constants';

export interface SearchViewSwitcherProps {
  mode: SearchViewMode;
  setMode: (mode: SearchViewMode) => void;
  onClick?: (view: SearchViewMode) => void;
}

const SearchViewSwitcher: React.FC<SearchViewSwitcherProps & { investorsMode?: boolean; }> = ({ investorsMode, ...rest }) => {
  if (investorsMode) return <InvestorsViewSwitcher {...rest} />;

  return <ListViewSwitcher {...rest} />;
};

export default SearchViewSwitcher;
